import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { AuthFacade } from 'src/app/services/facades/auth/auth.facade';
import { FirebaseAuthService } from 'src/app/services/firebase-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor
{
    constructor(
        private auth: AuthFacade,
        private firebaseAuth: FirebaseAuthService,
    ) { }

    attachHeaders(req: HttpRequest<any>, token: string = '') : HttpRequest<any>
    {
        return req.clone({ setHeaders: {
            'Authorization': `Bearer ${token}`
        }});
    }

    handleUnauthorizedErrorResponse(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>>
    {
        return from(this.firebaseAuth.getIdToken(true)).pipe(
            switchMap((token) => {
                if (!token) {
                    this.auth.logout();
                    return throwError(error);
                }
                req = this.attachHeaders(req, token);
                return next.handle(req);
            }),
            catchError(e => {
                this.auth.logout();
                return throwError(e);
            })
        );
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        return this.auth.state.token$
        .pipe(
            take(1),
            switchMap(token =>
            {
                if (token) {
                    req = this.attachHeaders(req, token);
                }
                return next.handle(req)
                .pipe(
                    catchError(e =>
                    {
                        if(e instanceof HttpErrorResponse && e.status === 401 && token)
                            return this.handleUnauthorizedErrorResponse(e, req, next);
                        else return throwError(e);
                    })
                );
            })
        );
    }
}
